import { httpGet } from "utils/httpRequest"

const getFaqList = async () => {
  const resp = await httpGet("web/faq/list")
  return resp.data
}

export { getFaqList }
